import { createSelector } from '@ngrx/store';
import { AppState, FooterState } from '@nx-customer-apps/shared/interfaces';

export namespace FooterSelectors {
    const footerState = (state: AppState) => state.footer;

    export const getState = () => createSelector(footerState, (state: FooterState) => state);
}
